let sharedMeasureCanvas;

export function measureTextWidth(text, font) {
  if (typeof document === "undefined") return 0;
  if (!sharedMeasureCanvas) {
    sharedMeasureCanvas = document.createElement("canvas");
  }

  const context = sharedMeasureCanvas.getContext("2d");
  if (!context) return 0;

  context.font = font;

  return context.measureText(text ?? "").width;
}
